import { Link } from 'react-router-dom';

export default function ArticleSection() {
  return (
    <section className="relative py-16 md:py-24 px-6 md:px-12 lg:px-20 bg-gradient-to-b from-foreground-900 to-foreground-950">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8">
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-accent-500/15 rounded-md mb-6">
            <span className="text-accent-400 text-xs font-medium whitespace-nowrap">/ Artikel</span>
          </div>
          <h2 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-white leading-tight max-w-2xl mb-5">
            Was ist OOPBUY Spreadsheet?
          </h2>
          <p className="text-white/65 text-sm md:text-base leading-relaxed max-w-xl mb-10">
            Ein OOPBUY Spreadsheet ist eine strukturierte Produktübersicht, mit der Nutzer schnell interessante Artikel, Verkäufer und Kategorien finden können. Entdecke, wie diese revolutionäre Methode dein Shopping-Erlebnis verändern kann.
          </p>
        </div>

        <div className="flex flex-col lg:flex-row items-start gap-8 lg:gap-16">
          <div className="w-full lg:w-1/2">
            <img
              src="https://readdy.ai/api/search-image?query=organized%20digital%20product%20catalog%20spreadsheet%20with%20fashion%20items%20displayed%20in%20clean%20grid%20layout%2C%20minimalist%20data%20visualization%20interface%2C%20warm%20cream%20and%20beige%20tones%2C%20modern%20European%20software%20design%20aesthetic%2C%20soft%20ambient%20lighting%20on%20screen%2C%20professional%20tech%20presentation&width=800&height=800&seq=article-img-new-v2&orientation=squarish"
              alt="OOPBUY Spreadsheet Übersicht"
              className="w-full aspect-square object-cover rounded-lg"
            />
          </div>

          <div className="w-full lg:w-1/2 flex flex-col justify-between">
            <div>
              <span className="text-6xl md:text-8xl font-heading font-bold text-white/10">01</span>
              <div className="-mt-4">
                <h3 className="text-lg md:text-xl font-heading font-semibold text-white mb-3">
                  Die komplette OOPBUY Spreadsheet Liste 2026
                </h3>
                <p className="text-white/55 text-sm leading-relaxed mb-2">
                  Unser detaillierter Guide erklärt Schritt für Schritt, wie du OOPBUY Spreadsheet optimal nutzt. Von der ersten Suche bis zum erfolgreichen Kauf — wir begleiten dich durch den gesamten Prozess mit praxisnahen Tipps und aktuellen Informationen.
                </p>
                <p className="text-white/55 text-sm leading-relaxed">
                  Erfahre, welche Kategorien am beliebtesten sind, wie du Verkäufer bewertest und worauf du bei QC achten musst. Alles, was du für ein sicheres und erfolgreiches Shopping-Erlebnis brauchst.
                </p>
              </div>
            </div>

            <Link
              to="/oopbuy-spreadsheet-guide"
              className="inline-flex items-center gap-2 mt-8 px-7 py-3.5 bg-white text-foreground-900 text-sm font-semibold rounded-full hover:bg-white/90 transition-all whitespace-nowrap cursor-pointer self-start"
            >
              Artikel lesen
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-sm"></i>
              </span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}